import { get_safe_internal_path } from "@core/helpers/auth-redirect";

/**
 * مسیر صفحه‌ی «درخواست فروشندگی».
 *
 * آدرس از route_names بک‌اند خوانده می‌شود (`seller-request`) و ممکن است فارسی باشد، پس
 * `usePathname` یا هدر `x-pathname` ممکن است آن را percent-encoded برگردانند.
 * هر مقایسه‌ای روی نسخه‌ی decode‌شده‌ی هر دو طرف انجام می‌شود.
 */
export const SELLER_REQUEST_ROUTE_KEY = "seller-request";

const FALLBACK_PATH = "/seller-academy-form/";

/** کوئری‌پارامتری که صفحه‌ی مبدأ (جایی که دکمه زده شد) را نگه می‌دارد. */
export const SELLER_REQUEST_BACK_PARAM = "back";

const safe_decode = (value = "") => {
	try {
		return decodeURIComponent(value);
	} catch {
		return value;
	}
};

const with_trailing_slash = (value = "") => (value.endsWith("/") ? value : `${value}/`);

export const get_seller_request_path = (web_route_names) =>
	web_route_names?.[SELLER_REQUEST_ROUTE_KEY] || FALLBACK_PATH;

export const is_seller_request_path = (pathname, web_route_names) => {
	if (!pathname) return false;
	const target = with_trailing_slash(safe_decode(get_seller_request_path(web_route_names)));
	return with_trailing_slash(safe_decode(pathname.split("?")[0])) === target;
};

/** لینک صفحه‌ی درخواست، همراه صفحه‌ای که کاربر از آن آمده است. */
export const build_seller_request_href = (web_route_names, back_path) => {
	const path = get_seller_request_path(web_route_names);
	// فقط مسیر داخلی، تا پارامتر `back` کاربر را به سایت دیگری نفرستد
	const back = get_safe_internal_path(back_path, { auth_path: false });
	if (!back) return path;
	return `${path}?${SELLER_REQUEST_BACK_PARAM}=${encodeURIComponent(back)}`;
};
